import {ASync} from "../PA.Core/Basic/ASync";
import {IPolicy} from "../PA.Core/PA.Core.IF.Policy";
import {BehaviorSubject} from "rxjs";
import * as _ from 'lodash'
import {MetricDefinitionBO} from "../PA.MD.BusinessObjects/MetricDefinition.BO";
import {WB_MetricDefinitionRow, WB_SubjectAreaRow} from "../PA.Core/PAdbSchemaRows";
import {PAEntity} from "../PA.Core/PAEntity";
import {esWB_Subject_Area} from "../PA.Core/PAdbSchema";


export class MetricDefinitionPolicy
    implements IPolicy {
    _metricDefinition: MetricDefinitionBO
    _metricDefinitionRow: WB_MetricDefinitionRow
    _PolicyChanged: BehaviorSubject<IPolicy>
    _bColumnCreatedInd: boolean
    _isLoaded: boolean

    constructor(metricDefinition: MetricDefinitionBO) {
        this._metricDefinition = metricDefinition
        this._metricDefinitionRow = metricDefinition.WB_MetricDefinition
        this._PolicyChanged = new BehaviorSubject<IPolicy>(this)
        this._bColumnCreatedInd = false
    }

    get OnLoadComplete(): Promise<void> {
        const self = this

        if (self._isLoaded)
            return ASync.resolve()


        return new Promise<void>((resolve, error) => {
            self._isLoaded = true
            self._metricDefinition.OnLoadComplete
                .then((ignore) => {
                    self.refreshPolicy()
                })
                .catch((err) => {
                    console.log(err)
                })
            resolve();
        })
    }


    // Add Editbility/ Visibility Properties for all the Elements of an Event
    get bSubjectAreaEditable(): boolean {
        return !this._bColumnCreatedInd;
    }

    get bSubjectAreaColumnNameEditable(): boolean {
        return !this._bColumnCreatedInd;
    }

    get PolicyChanged(): BehaviorSubject<IPolicy> {
        return this._PolicyChanged
    }

    async refreshPolicy(bForce?: boolean): Promise<void> {
        const self = this

        if((!self._isLoaded)  && (!bForce))
            return

        let subjectAreaRow: WB_SubjectAreaRow = undefined
        if (self._metricDefinition?.WB_MetricDefinition?.cif?.WB_SUBJECTAREA_ID > 0) {
            subjectAreaRow = await self._metricDefinition.dbContext.find(esWB_Subject_Area, self._metricDefinition.WB_MetricDefinition.cif.WB_SUBJECTAREA_ID)
        }

        if (_.isEmpty(subjectAreaRow) || _.isEmpty((self._metricDefinition?.WB_MetricDefinition?.cif?.SUBJECTAREA_COLUMNNAME))) {
            self._bColumnCreatedInd = false;
            self._PolicyChanged.next(self)
            return
        }

        let tableName = subjectAreaRow.cif.SOURCE_NAME;
        let columnName = self._metricDefinition.WB_MetricDefinition.cif.SUBJECTAREA_COLUMNNAME;
        let aPAEntity = new PAEntity()
        let columnExists = await aPAEntity.checkEntityColumnExists(0, tableName, columnName)

        self._bColumnCreatedInd = columnExists
        self._PolicyChanged.next(self)

    }

}


